import { Map, OrderedSet } from 'immutable';

import * as types from './types';
import * as containerTypes from './../container/types';
import * as helpers from './../../query/helpers';
import * as constants from './constants';
import { parseFilters, validateFilter } from './utils';

const { startDate, endDate } = helpers.getAssetsTimeOffset();

export const initialState = Map({
  filters: Map().withMutations((map) => {
    constants.FILTERS_MAP.map((value, key) => (
      map.set(key, Map({
        loading: false,
        items: OrderedSet(constants.FILTER_DEFAULT_ITEMS[key] || []),
        labels: null,
        selectedItems: OrderedSet(),
      }))
    ));
  }),
  query: Map({
    page: 1,
  }),
  filterDate: Map({
    startDate,
    endDate,
  }),
  users: Map(),
  teams: Map(),
});

export const filtersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.CHANGE_PAGE: {
      return state.setIn(['query', 'page'], payload);
    }
    case types.UPDATE_QUERY: {
      const query = state.get('query');
      return state.set('query', query.merge(Map(payload)));
    }
    case types.RESET_PAGE:
      return state.setIn(['query', 'page'], initialState.getIn(['query', 'page']));
    case types.FETCH_FILTERS.SUCCESS: {
      const parsedFilters = parseFilters(payload);
      const existingFilters = state.get('filters');
      const newFilters = existingFilters.map((value, key) => (
        parsedFilters[key] ? value.set('items', OrderedSet(parsedFilters[key])) : value
      ));
      return state.set('filters', newFilters);
    }
    case types.UPDATE_FILTER: {
      if (payload.name === 'date') {
        return state.set('filterDate', payload.data);
      }

      return state.setIn(['filters', payload.name, 'selectedItems'], payload.data.items);
    }
    case types.CHANGE_URL_QUERY_TO_FILTERS: {
      const {
        page,
        startDate: start,
        endDate: end,
        ...filters
      } = payload;
      const existingFilters = state.get('filters');
      return state.withMutations((newState) => {
        if (page) {
          newState.setIn(['query', 'page'], Number(page));
        }
        if (start && end) {
          newState.set('filterDate', Map({
            startDate: new Date(start),
            endDate: new Date(end),
          }));
        }
        Object.entries(filters).forEach(([key, value]) => {
          if (
            existingFilters.get(key) &&
            validateFilter(key, value, existingFilters.getIn([key, 'items']))
          ) {
            newState.setIn(['filters', key, 'selectedItems'], OrderedSet(value));
          }
        });
      });
    }
    case types.GET_USERS.SUCCESS: {
      const users = payload.results.reduce((acc, { username, id }) => ({
        ...acc,
        [username]: id,
      }), {});
      return state.withMutations((newState) => {
        newState
          .set('users', Map(users))
          .setIn(['filters', 'owner', 'items'], OrderedSet(Object.keys(users)));
      });
    }
    case types.GET_TEAMS.SUCCESS: {
      const teams = payload.results.reduce((acc, { name, id }) => ({
        ...acc,
        [name]: id,
      }), {});
      return state.withMutations((newState) => {
        newState
          .set('teams', Map(teams))
          .setIn(['filters', 'team', 'items'], OrderedSet(Object.keys(teams)));
      });
    }
    case containerTypes.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default filtersReducer;
